<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on" color="black">
        <v-icon>mdi-account-plus-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">Adding User</v-card-title>
      <v-card-text
        >{{ info }}
        <v-form ref="AddUserForm">
          <v-text-field
            v-model="pasword1"
            :rules="[requiredFild, lengthPass]"
            name="namePass1"
            label="New Password"
            id="idPass1"
            required
          ></v-text-field>
          <v-text-field
            validate-on-blur
            v-model="pasword2"
            :rules="[MutchPassword]"
            name="namePass2"
            label="Confirm"
            id="idPass2"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" :disabled="clicked" text @click="close"
          >Cancel</v-btn
        >
        <v-btn color="green darken-1" :loading="clicked" text @click="OnAddUser"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: { ClientInfo: { type: Object, required: true } },
  data() {
    return {
      clicked: false,
      info:
        "If the User is alread exists his password will change, other wise new user will create",
      dialog: false,
      pasword1: "",
      pasword2: "",
    };
  },
  methods: {
    OnAddUser() {
      // console.log(this.$refs.AddUserForm);
      if (this.$refs.AddUserForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/customer/adduser",
            data: {
              ...this.ClientInfo,
              pass1: this.pasword1,
              pass2: this.pasword2,
            },
          })
          .then(() => {
            this.clicked = false;
            // console.log(value);
            this.close();
          })
          .catch(() => {
            this.clicked = false;
            // console.log(error);
          });
      }
    },
    close() {
      this.dialog = false;
      this.$refs.AddUserForm.reset();
    },
    requiredFild(v) {
      // return !!v || "Password is required";
      if (!v) return "Password is required";
      return true;
    },
    MutchPassword(v) {
      return v == this.pasword1 || "Password is not equal";
    },
    lengthPass(v) {
      if (!v) return "Empty";
      else if (v.length <= 5)
        return "Password must be greater than 5 characters";
      return true;
    },
  },
};
</script>
